import { useCallback, useEffect, useState } from "react";
import { masterMerchantService } from "../Services/masterMerchant.service";
import useApiServices from "../utils/useApiServices";

export const useMasterMerchants = () => {
  const api = useApiServices();
  const service = masterMerchantService(api);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const res = await service.getAll();
      const mapped = (res?.data || []).map((item) => ({
        ...item,
        id: item.masterMerchantId,
      }));
      setData(mapped);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  return {
    data,
    loading,
    refetch: fetchAll,
  };
};
